module.exports = __webpack_public_path__ + "officialStatic/img/detail-one4.3edd83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-one4.png
// module id = GT16
// module chunks = 0